@import '../../../global/styles/focus.scss';
@import '../../../global/styles/media-queries.scss';

:host {
    --back-button-height: 100%;
    --back-button-padding-bottom: inherit;
    --height: 48px;
    --half-height: 36px;
    --neg-half-height: -34px;
    --font-family: 'arv-open-sans';
    --font-size: 16px;
    --font-weight: 400;

    --default-background-rgba: black;
    --default-text-rgba: black;
    --default-underline-rgba: black;
    --default-border-rgba: 1px solid #ffffff00;
    --hover-background-rgba: black;
    --hover-text-rgba: black;
    --hover-border-rgba: 1px solid #ffffff00;
    --border-radius: 0px;

    --text-margin-left: auto;
    --text-margin-right: auto;

    background-color: var(--default-background-rgba);
    border-radius: var(--border-radius);
    transition: all 0.3s linear;

    display: flex;
    align-items: center;
    height: var(--height);
    padding: auto 0;

    box-sizing: border-box;
    border: 1px solid var(--default-border-rgba);

    button {
        width: 100%;
        height: 100%;
        background: none;
        outline: none;
        color: inherit;
        border: none;
        font: inherit;
        padding: 0 3px;

        &:focus-visible {
            @include on-focus;
        }

        &.blue-focus:focus {
            text-decoration: underline;
        }
    }

    a {
        &:focus-visible {
            @include on-focus;
        }
    }

    a.icon-text {
        height: var(--back-button-height);
        padding-bottom: var(--back-button-padding-bottom);
    }

    button,
    a,
    a:visited {
        color: var(--default-text-rgba);
        width: 100%;
        height: 100%;
        cursor: pointer;
        text-decoration: none;
        display: inline-block;
        background-image: linear-gradient(var(--default-underline-rgba) 0 0);
        background-position: 0 100%;
        background-size: 0% 1px;
        background-repeat: no-repeat;
        transition: background-size 0.3s, background-position 0s 0.3s;

        &.padding {
            padding-left: 24px;
            padding-right: 24px;
            box-sizing: border-box;
        }

        .container {
            height: var(--half-height);

            margin: auto;
            margin-left: var(--text-margin-left);
            margin-right: var(--text-margin-right);

            overflow: hidden;

            .content {
                transition: all 330ms cubic-bezier(0.4, 0, 0.2, 1);
                transform: translateY(0);
                font-family: var(--font-family);
                font-weight: var(--font-weight);
                font-size: var(--font-size);
                line-height: var(--half-height);
                white-space: nowrap;

                @include on-mobile {
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 350px;
                }
            }
        }
    }

    .icon-text {
        display: flex;
        flex-direction: row;
        align-items: center;

        .icon {
            path {
                stroke: var(--default-text-rgba);
            }

            &.left {
                margin-right: 8px;
            }

            &.right {
                margin-left: 8px;
            }
        }
    }
}

:host(.active),
:host(:hover) {
    background-color: var(--hover-background-rgba);
    border: 1px solid var(--hover-border-rgba);

    button,
    a,
    a:visited {
        color: var(--hover-text-rgba);
        background-position: 100% 100%;
        background-size: 100% 1px;

        .container {
            .content {
                transform: translateY(var(--neg-half-height));
            }
        }
    }

    a {
        color: var(--hover-text-rgba);
    }

    .icon-text {
        .icon {
            path {
                stroke: var(--hover-text-rgba);
            }
        }
    }
}

:host(.active) {
    button,
    a {
        cursor: default;
    }
}

:host(.invertLineVisibility) {
    background-color: var(--hover-background-rgba);
    border: 1px solid var(--hover-border-rgba);

    button,
    a,
    a:visited {
        color: var(--hover-text-rgba);
        background-position: 100% 100%;
        background-size: 100% 1px;

        .container {
            .content {
                transform: translateY(var(--neg-half-height));
            }
        }
    }

    a {
        color: var(--hover-text-rgba);
    }

    .icon-text {
        .icon {
            path {
                stroke: var(--hover-text-rgba);
            }
        }
    }
}

:host(.invertLineVisibility:hover) {
    background-color: var(--default-background-rgba);
    border: 1px solid var(--default-border-rgba);

    button,
    a,
    a:visited {
        color: var(--default-text-rgba);
        background-image: linear-gradient(var(--default-underline-rgba) 0 0);
        background-position: 0 100%;
        background-size: 0% 1px;
        background-repeat: no-repeat;
        transition: background-size 0.3s, background-position 0s 0.3s;

        .container {
            .content {
                transition: all 330ms cubic-bezier(0.4, 0, 0.2, 1);
                transform: translateY(0);
            }
        }
    }

    .icon-text {
        .icon {
            path {
                stroke: var(--default-text-rgba);
            }
        }
    }
}
